const CLASS_NAME = 'js-frozen';

// froze all actions on draggable elements
export const froze = () => document.body.classList.add(CLASS_NAME);
export const unfroze = () => document.body.classList.remove(CLASS_NAME);
